import {React, useEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import tick from '../images/liaison/tick.png'

function LiaisonServiceCard () {

    useEffect(()=>{
        AOS.init({duration:1000});
      }, []);

        const serviceCard_1 =[
        {
            heading : "Consultation",
            service1 : "Market Analysis",
            service2 : "Land Surveying",
            service3 : "Soil Test",
            service4 : "Digital Survey",
            service5 : "Legal Opinion",
            service6 : "Government Pleader Opinion",
            service7 : "Approval Feasibility Checking ",
            service8 : "Project Designing",
            service9 : "Due Diligence",
        }
    ]  
    const serviceCard_2 =[
        {
            heading : "Government NOCs",
            service1 : "Agriculture",
            service2 : "Health",
            service3 : "Forest",
            service4 : "Geology & Mining",
            service5 : "Environment Clearance & Mining",
            service6 : "Traffic Police",
            service7 : "Fire",
            service8 : "Airport",
            service9 : "Electricity Board",  
            service10 : "Water & Sewage Board and Tax Assessment",  
            service11 : "Building Plan Approval/Reapproval",  
            service12 : "PWD",  
            service13 : "National Highway ",  
            service14 : "State Highway",  
            service15 : "Environmental Impact Assessment (EIA)",  
            service16 : "Railway",  
            service17 : "Police Department ",  
            service18 : "Health Department",  
            service19 : "Tahsildar NOC",  
            service20 : "Warehouse NOC",  
        }
    ]

    const serviceCard_3 = [
        {
            heading : "Operational Clearance and Approvals",
            service1 : "Layout Approval",
            service2 : "Land use Conversion",
            service3 : "Building Completion Plan & Certificate",
            service4 : "Building plan approval at Corporation",
            service5 : "Building plan approval at DTCP",
            service6 : "Vacant Land Tax Assessment",
            service7 : "DD Plan alteration",
            service8 : "Property  Tax Assessment",
            service9 : "Property Tax Name Transfer",  
            service10 : "EB & Water Name Transfer",  
            service11 : "Regularisation for sites",  
            service12 : "Regularisation of Unapproved Layout",  
            service13 : "Fencing Work",  
            service14 : "eDCR & preDCR works",  
        }
    ]

        const serviceCard_4 = [
        {
            heading : "Revenue Department Documents",
            service1 : "Chitta-Patta / TSLR Name Transfer",
            service2 : "Adangal Extract",
            service3 : "FMB copy ",
            service4 : "RSR copy",
            service5 : "TSLR drawing & report",
            service6 : "Sub division",
            service7 : "Survey",
        },
    ]

        const serviceCard_5 = [

        {
            heading : "Documentation Works",
            service1 : "Encumbrance Certificate",
            service2 : "Sale Deed, Settlement deed, Will & Partition Deed",
            service3 : "Rental Agreement",
            service4 : "Sale Agreement",
            service5 : "Copy Document",
        },
    ]

    return(

        <>
        
            <div className='my-[130px]' id="liaison-services">
                <h2 className="heading" data-aos="fade-up">Comprehensive Service Offerings</h2>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800"/>
            </div>

            {/* Looping card */}
            <div className="md:max-w-6xl mx-auto px-6 flex flex-wrap justify-around">

                <div>

                    {/* Card-1 */}
                    {
                        serviceCard_1.map((item) => {
                            return(
                                <div className="max-w-[540px] mx-auto mb-14" data-aos="fade-up">

                                    <h2 className="liaisonservices-heading ">{item.heading}</h2>
                                    <hr className='border-yellow border-[1.5px] mt-[15px]' />

                                    <ul className="ml-2 my-5 icon-list font-alibaba text-[#5F5D5E] text-[18px]" style={{ listStyle: 'disc' }} >
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service1}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service2}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service3}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service4}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service5}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service6}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service7}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service8}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service9}</li>
                                    </ul>
                                </div>
                            )
                        })
                    }


                    {/* Card-2 */}
                    {
                        serviceCard_2.map((item) => {
                            return(
                                <div className="max-w-[540px] mx-auto mb-14" data-aos="fade-up">

                                    <h2 className="liaisonservices-heading ">{item.heading}</h2>
                                    <hr className='border-yellow border-[1.5px] mt-[15px]' />

                                    <ul className="ml-2 my-5 icon-list font-alibaba text-[#5F5D5E] text-[18px]" style={{ listStyle: 'disc' }} >
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service1}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service2}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service3}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service4}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service5}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service6}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service7}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service8}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service9}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service10}</li> 
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service11}</li> 
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service12}</li> 
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service13}</li> 
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service14}</li> 
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service15}</li> 
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service16}</li> 
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service17}</li> 
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service18}</li> 
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service19}</li> 
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service20}</li>    
                                    </ul>
                                </div>
                            )
                        })
                    }

                </div>
                

                {/* Second div */}
                <div>
                    
                    {/* Card-3 */}
                    {
                        serviceCard_3.map((item) => {
                            return(
                                <div className="max-w-[540px] mx-auto mb-14" data-aos="fade-up">

                                    <h2 className="liaisonservices-heading ">{item.heading}</h2>
                                    <hr className='border-yellow border-[1.5px] mt-[15px]' />

                                    <ul className="ml-2 my-5 icon-list font-alibaba text-[#5F5D5E] text-[18px]" style={{ listStyle: 'disc' }} >
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service1}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service2}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service3}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service4}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service5}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service6}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service7}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service8}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service9}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service10}</li> 
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service11}</li> 
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service12}</li> 
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service13}</li> 
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service14}</li> 
                                    </ul>
                                </div>
                            )
                        })
                    }

                    {/* Card-4 */}
                    {
                        serviceCard_4.map((item) => {
                            return(
                                <div className="max-w-[540px] mx-auto mb-14" data-aos="fade-up">

                                    <h2 className="liaisonservices-heading ">{item.heading}</h2>
                                    <hr className='border-yellow border-[1.5px] mt-[15px]' />

                                    <ul className="ml-2 my-5 icon-list font-alibaba text-[#5F5D5E] text-[18px]" style={{ listStyle: 'disc' }} >
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service1}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service2}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service3}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service4}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service5}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service6}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service7}</li>   
                                    </ul>
                                </div>
                            )
                        })
                    }

                    {/* Card-5 */}
                    {
                        serviceCard_5.map((item) => {
                            return(
                                <div className="max-w-[540px] mx-auto mb-14" data-aos="fade-up">

                                    <h2 className="liaisonservices-heading ">{item.heading}</h2>
                                    <hr className='border-yellow border-[1.5px] mt-[15px]' />

                                    <ul className="ml-2 my-5 icon-list font-alibaba text-[#5F5D5E] text-[18px]" style={{ listStyle: 'disc' }} >
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service1}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service2}</li>
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service3}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service4}</li>   
                                        <li className='flex gap-x-[15px]'><img className='w-[16px] h-[12px] my-auto' src={tick} alt='tick_icon' />{item.service5}</li>
                                    </ul>
                                </div>
                            )
                        })
                    }

                </div>

            </div>
        </>

    );
}

export default LiaisonServiceCard;    


{/* old Card design */}
{/* <div>
    {
        serviceCard_2.map((item) => {
            return(
                <div className="liaisonservice-card mb-14 shadow-xl" data-aos="fade-up">
                    <h2 className="liaisonservices-heading ">{item.heading}</h2>
                    <ul className="pl-4 my-5 font-[lato] text-[#363537] text-[18.846px] leading-[30.528px] tracking-[0.50px] " style={{ listStyle: 'disc' }} >
                        <li>{item.service1}</li>
                        <li>{item.service2}</li>
                        <li>{item.service3}</li>   
                        <li>{item.service4}</li>   
                        <li>{item.service5}</li>
                        <li>{item.service6}</li>   
                        <li>{item.service7}</li>   
                        <li>{item.service8}</li>   
                        <li>{item.service9}</li> 
                        <li>{item.service10}</li> 
                        <li>{item.service11}</li> 
                        <li>{item.service12}</li> 
                        <li>{item.service13}</li> 
                        <li>{item.service14}</li> 
                    </ul>
                </div>
            )
        })
    }
</div> */}